<template>
    <MeasurementsForm :client_id="client.id" :genre="client.genre" :item="measurement" @save="goToClient" @edit="goToClient"/>
</template>

<script>
import MeasurementsForm from '@/components/forms/MeasurementsForm.vue';

export default {
    name: 'MeasurementsCreate',
    components: { MeasurementsForm },
    props: {
        client_id: {
            type: [String, Number],
            required: true,
        },
        id: {
            type: [String, Number],
            required: false,
        }
    },
    watch: {
        client_id: {
            immediate: true,
            handler() {
                this.getClient();
            }
        },
        id: {
            immediate: true,
            handler() {
                this.getMeasurement();
            }
        }
    },
    data() {
        return {
            client: {},
            measurement: {}
        };
    },
    methods: {
        getClient() {
            return this.$api.get(`/clients/${this.client_id}`)
                .then(response => {
                    this.client = response.data.data;
                });
        },
        getMeasurement(){
            if(this.id){
                this.$api.get(`/mesures/${this.id}`)
                .then(response => {
                    this.measurement = response.data.data;
                });
            }
        },
        goToClient(client) {
            this.$router.push({ name: 'clients.view', params: { id: client.client_id } });
        },
    },

    created() {
        this.getClient();

    }
}
</script>